import { Component, EventEmitter, Output } from '@angular/core';
import { EntityType } from 'src/app/core/settings/settings.service';
import { Entity } from 'src/app/shared/entity-search/entity-search.service';
import { Company } from '../models/company';

@Component({
  selector: 'company-selector',
  templateUrl: './company-selector.component.html',
  styleUrls: ['./company-selector.component.scss'],
})
export class CompanySelectorComponent {
  @Output()
  companySelect: EventEmitter<Company> = new EventEmitter<Company>();

  entitySearchTypeFilter = EntityType.company;

  company: Company;

  onCompanySelect(entity: Entity) {
    this.company = {
      id: parseInt(entity.id),
      name: entity.name,
    };
    this.companySelect.emit(this.company);
  }

  clearCompany() {
    this.company = null;
    this.companySelect.emit(null);
  }
}
